<template>
  <div>
    <Dialog
      :key="userFormKey"
      :visible.sync="userForm1"
      :style="{ width: '900px', overflowY: 'auto' }"
      header="User Details"
      :modal="true"
      class="p-fluid"
    >
      <template #header>
        <h5>User Details</h5>

        <span
          v-if="user.status"
          :class="'ignore pointer badge ' + getStyle(user.status)"
        >
          {{ user.status }}
        </span>

        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </template>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="email">Email*</label>
          <InputText
            id="email"
            v-model.trim="email"
            required="true"
            type="email"
            autofocus
            :class="{ 'p-invalid': submitted && !user.email }"
            :disabled="disabledArr.includes('email')"
          />
          <small class="p-invalid" v-if="submitted && !user.email"
            >Email is required.</small
          >
          <small class="p-invalid" v-if="invalidEmail"
            >Email must be valid.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="firstName">First Name*</label>
          <InputText
            id="firstName"
            v-model.trim="user.firstName"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !user.firstName }"
            :disabled="disabledArr.includes('firstName')"
          />
          <small class="p-invalid" v-if="submitted && !user.firstName"
            >First Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Last Name*</label>
          <InputText
            id="lastName"
            v-model.trim="user.lastName"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !user.lastName }"
            :disabled="disabledArr.includes('lastName')"
          />
          <small class="p-invalid" v-if="submitted && !user.lastName"
            >Last Name is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="role">Role*</label>
          <Dropdown
            :showClear="true"
            v-model="user.role"
            :options="roles"
            optionLabel="roleName"
            dataKey="id"
            id="role"
            placeholder="Select Role"
            :disabled="disabledArr.includes('role')"
          />
          <small class="p-invalid" v-if="submitted && !user.role"
            >Role is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="defBranch">Branch</label>
          <Dropdown
            :showClear="true"
            v-model="user.defBranch"
            :options="mbpBranches"
            optionLabel="branchName"
            dataKey="id"
            id="defBranch"
            placeholder="Select Branch"
          />
        </div>
        <div class="p-field p-col">
          <label for="defRegion">Region</label>
          <Dropdown
            :showClear="true"
            v-model="user.defRegion"
            :options="regions"
            optionLabel="regionName"
            dataKey="id"
            id="defRegion"
            placeholder="Select Region"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="productType">Product Type</label>
          <Dropdown
            :showClear="true"
            v-model="user.defProdType"
            :options="productTypes"
            optionLabel="productTypeName"
            dataKey="id"
            id="productType"
            placeholder="Select product type"
            :disabled="disabledArr.includes('productType')"
          />
        </div>
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <Dropdown
            :showClear="true"
            v-model="user.salesExec"
            :options="salesExecs"
            optionLabel="salesExecName"
            dataKey="id"
            id="salesExec"
            placeholder="Select Sales Executive"
          />
        </div>
        <div class="p-field p-col">
          <label for="supervisor">Supervisor</label>
          <Dropdown
            :showClear="true"
            v-model="user.supervisor"
            :options="supervisors"
            optionLabel="fullName"
            dataKey="id"
            id="supervisor"
            placeholder="Select supervisor"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mbpDept">Department</label>
          <Dropdown
            :showClear="true"
            v-model="user.mbpDept"
            :options="mbpDepts"
            optionLabel="deptName"
            dataKey="id"
            id="mbpDept"
            placeholder="Select Department"
          />
        </div>
        <div class="p-field p-col"></div>
        <div class="p-field p-col"></div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="getReminderEmail">Get task and event reminder emails</label>
          <br />
          <InputSwitch
            v-model="user.getReminderEmail"
            autofocus
            :disabled="disabledArr.includes('getReminderEmail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="getReminderEmails">Get notes emails</label>
          <br />
          <InputSwitch
            v-model="user.getNotesEmail"
            autofocus
            :disabled="disabledArr.includes('getReminderEmails')"
          />
        </div>
        <div class="p-field p-col">
          <label for="getCustApproveEmail">Get customer approval emails</label>
          <br />
          <InputSwitch
            v-model="user.getCustApproveEmail"
            autofocus
            :disabled="disabledArr.includes('getReminderEmails')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="createOutlookActivity">Create Outlook Event</label>
          <br />
          <InputSwitch
            v-model="user.createOutlookActivity"
            autofocus
            :disabled="disabledArr.includes('createOutlookActivity')"
          />
        </div>
        <div class="p-field p-col">
          <!-- Stage 1, two-way Outlook: Admin only, as Create Outlook Event -->
          <label for="outlookTodoSync">Microsoft To Do (tasks)</label>
          <br />
          <InputSwitch
            id="outlookTodoSync"
            v-model="user.outlookTodoSync"
            :disabled="disabledArr.includes('createOutlookActivity')"
          />
          <small class="p-d-block">{{ todoHelp }}</small>
        </div>
      </div>
      <OutlookUserSyncStatus v-if="user && user.id" :userId="user.id" />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <!-- <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="roles">Roles*</label>
          <Roles
          />
        </div>
      </div> -->

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import SettingService from "@/service/SettingService";
import CustomerService from "@/service/CustomerService";
import UserService from "@/service/UserService";
import OpportunityService from "@/service/OpportunityService";

import Roles from "./Roles";

import { sendUser } from "../sendRequest";
import OutlookUserSyncStatus from "@/mbp/outlookSync/OutlookUserSyncStatus.vue";
import { TODO_HELP } from "@/mbp/outlookSync/outlookSync";

export default {
  components: {
    OutlookUserSyncStatus,
    Roles
  },
  created() {
    this.getMBPDepts();
    this.getAllActiveRegions();
    this.getAllActiveMBPBranches();
    this.getAllActiveSalesExecs();
    this.getActiveRoles();
    this.getAllActiveUsersByHard();
    this.getAllActiveProductTypes();

    this.setupComponent();
  },
  props: {
    userForm: {
      required: true,
      type: Boolean
    },
    reloadForm: {
      required: false,
      type: Number
    },
    reloadSupervisors: {
      required: false,
      type: Number
    },
    disabledArr: {
      required: true,
      type: Array
    },
    userToEdit: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    todoHelp: TODO_HELP,
    settingService: new SettingService(),
    customerService: new CustomerService(),
    userService: new UserService(),
    opportunityService: new OpportunityService(),
    userFormKey1: 0,
    submitted: false,
    sendingRequest: false,
    user: {
      status: { id: 1, statusName: "New" }
    },
    email: "",
    invalidEmail: false,

    mbpDepts: [],
    supervisors: [],
    regions: [],
    mbpBranches: [],
    salesExecs: [],
    statuses: [
      { id: 1, statusName: "New" },
      { id: 2, statusName: "Active" },
      { id: 3, statusName: "InActive" },
      { id: 4, statusName: "Suspended" }
    ],
    roles: [],
    productTypes: []
  }),
  computed: {
    userFormKey: {
      set(val) {
        this.userFormKey1++;
      },
      get() {
        //
        return "userFormKey-" + this.userFormKey1.toString();
      }
    },
    userForm1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.userForm;
      }
    }
  },
  watch: {
    userForm(val) {
      this.userFormKey = this.userFormKey1 + 1;
    },
    reloadForm(val) {
      this.setupComponent();
    },
    reloadSupervisors(val) {
      this.getAllActiveUsersByHard();
    },
    email(val) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let a = re.test(String(val).toLowerCase());
      if (a) {
        this.user.email = val;
        this.invalidEmail = false;
      } else {
        this.user.email = "";
        this.invalidEmail = true;
      }
    }
  },
  methods: {
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data === "ACTIVE") {
        return "badge-success";
      } else if (data === "INACTIVE") {
        return "badge-danger";
      } else {
        return "badge-dark";
      }
      // if (data && data.colourCode) {
      //   return data.colourCode
      // } else if (data && data.statusName && data.statusName.toLowerCase() === 'suspended') {
      //   return 'badge-danger'
      // } else if (data && data.statusName && data.statusName.toLowerCase() === 'active') {
      //   return 'badge-primary'
      // } else if (data && data.statusName && data.statusName.toLowerCase() === 'new') {
      //   return 'badge-success'
      // } else if (data && data.statusName && data.statusName.toLowerCase() === 'inactive') {
      //   return 'badge-secondary'
      // } else {
      //   return 'badge-dark'
      // }
    },
    setupComponent() {
      this.submitted = false;
      this.sendingRequest = false;
      this.email = "";

      if (this.userToEdit && this.userToEdit.id) {
        this.user = this.userToEdit;
        if (this.userToEdit.email) {
          this.email = this.userToEdit.email;
        }
      } else {
        this.user = {
          status: { id: 1, statusName: "New" }
        };
      }
    },
    save() {
      //
      this.submitted = true;
      this.sendingRequest = true;

      sendUser(this, "UserForm.vue");
    },
    getMBPDepts() {
      this.settingService
        .getMBPDepts()
        .then(data => (this.mbpDepts = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting MBP departments",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "mbpdepts"'
          });
        });
    },
    getAllActiveUsersByHard() {
      this.userService
        .getAllActiveUsersByHard()
        .then(data => {
          this.supervisors = data;
        })
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting users",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeUsers"'
          });
        });
    },
    getAllActiveRegions() {
      this.customerService
        .getAllActiveRegions()
        .then(data => (this.regions = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting regions",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeRegions"'
          });
        });
    },
    getAllActiveMBPBranches() {
      this.customerService
        .getAllActiveMBPBranches()
        .then(data => (this.mbpBranches = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting MBP mbpBranches",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeMbpBranches"'
          });
        });
    },
    getAllActiveSalesExecs() {
      this.customerService
        .getAllActiveSalesExecs()
        .then(data => (this.salesExecs = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting sales exec",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeSalesExecs"'
          });
        });
    },
    getActiveRoles() {
      this.userService
        .getActiveRoles()
        .then(data => {
          this.roles = data;
        })
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting users",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeRoles"'
          });
        });
    },
    getAllActiveProductTypes() {
      this.opportunityService
        .getAllActiveProductTypes()
        .then(data => {
          this.productTypes = data;
        })
        .catch(e => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeProductTypes"'
          });
        });
    }
  }
};
</script>

<style scoped>
.pointer {
  cursor: auto;
  font-size: 16px;
}
</style>
